import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { ProjectSynthesisJobType } from '@Pages/RetroSynthesis/constants';
import { ProgressLoader } from '@els/els-react--progress-loader';

function RoutesLoaderInQueue({ type, queuePosition }) {
  const position = String(queuePosition);
  return (
    <>
      <div
        className={cn(
          'project-status-grid-item__routes-loader',
          'project-status-grid-item__routes-loader--in-queue',
          `project-status-grid-item__routes-loader--${type}`
        )}>
        <ProgressLoader size="small" currentPercentage={position} />
      </div>
      <span className="project-status-grid-item__routes-loader-label">In queue</span>
    </>
  );
}

RoutesLoaderInQueue.propTypes = {
  type: PropTypes.oneOf(ProjectSynthesisJobType.allTypes),
  queuePosition: PropTypes.string,
};

export default RoutesLoaderInQueue;
